module.exports = __webpack_public_path__ + "img/State_test_Practice.8130a9f0.svg";